export default __webpack_public_path__ + "down-arrow.png";